var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.143,32C4.093,32,0,35.325,0,39.429A6.593,6.593,0,0,0,2.036,44.1,9.086,9.086,0,0,1,.079,47.518a.284.284,0,0,0-.054.311A.28.28,0,0,0,.286,48a8.168,8.168,0,0,0,5.021-1.836,10.892,10.892,0,0,0,3.836.693c5.05,0,9.143-3.325,9.143-7.429S14.193,32,9.143,32ZM4.571,40.571a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,4.571,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,9.143,40.571Zm4.571,0a1.143,1.143,0,1,1,1.143-1.143A1.142,1.142,0,0,1,13.714,40.571Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentDots);
export default __webpack_public_path__ + "static/media/comment-dots.8a4bb4b2.svg";
export { ForwardRef as ReactComponent };